// extracted by mini-css-extract-plugin
export default {"container":"Ica-z","oos":"Jca-z","oosUx":"Kca-z","selected":"Lca-z","labelOos":"Mca-z"};